import { string } from 'yup';

import { palette } from './assets/colors';

export const TILE_HEIGHT = 294;
export const TILE_WIDTH = 266;

export const SVG_PROPS = {
  width: TILE_WIDTH,
  height: TILE_HEIGHT,
  viewBox: `0 0 ${TILE_WIDTH} ${TILE_HEIGHT}`,
};

type LevelNumber = 1 | 2 | 3 | 4;
type LevelType = {
  level: LevelNumber;
  points: number;
  title: string;
  color: string;
};

export const LEVELS: Record<LevelNumber, LevelType> = {
  1: {
    level: 1,
    points: 0,
    title: 'n00b',
    color: palette.yellow,
  },
  2: {
    level: 2,
    points: 200,
    title: 'CDP Expert',
    color: palette.blue,
  },
  3: {
    level: 3,
    points: 1000,
    title: 'Developer Maverick',
    color: palette.green,
  },
  4: {
    level: 4,
    points: 2000,
    title: 'Onchain Pioneer',
    color: palette.pink,
  },
};

export const qAndASchema = string().required('Please enter an answer.');

const twitterLinkError = 'Please enter a valid X.com link';
const twitterLinkPattern =
  /^(https:\/\/)?(www\.)?(x|twitter)\.com\/[A-Za-z0-9_]{1,15}\/status(\/)?.+$/;
export const twitterLinkSchema = string().required(twitterLinkError).matches(twitterLinkPattern, {
  excludeEmptyString: true,
  message: twitterLinkError,
});

const discordLinkError = 'Please enter a valid Discord link';
const discordLinkPattern =
  /^(https:\/\/)?(www\.)?discord\.com\/channels\/1220414409550336183(\/)?.+$/;
export const discordLinkSchema = string().required(discordLinkError).matches(discordLinkPattern, {
  excludeEmptyString: true,
  message: discordLinkError,
});

const githubRepoError = 'Please enter a valid GitHub repo link';
const githubRepoPattern =
  /^(https:\/\/)?(www\.)?github\.com\/[A-Za-z0-9](?!.*--)[A-Za-z0-9-]{0,37}\/[\w.-]+(\.git)?(\/)?.+$/;
export const githubRepoSchema = string().required(githubRepoError).matches(githubRepoPattern, {
  excludeEmptyString: true,
  message: githubRepoError,
});

const twitterOrDiscordLinkError = 'Please enter a valid X.com or Discord link';
const twitterOrDiscordLinkPattern = new RegExp(
  `(${twitterLinkPattern.source})|(${discordLinkPattern.source})`,
);
export const twitterOrDiscordLinkSchema = string()
  .required(twitterOrDiscordLinkError)
  .matches(twitterOrDiscordLinkPattern, {
    excludeEmptyString: true,
    message: twitterOrDiscordLinkError,
  });
